module.exports = __webpack_public_path__ + "img/mac1.cb2af235.webp";